export const isProd = process.env.NODE_ENV === "production";

export function getEnvironment() {
  let env = "development";

  const customEnv = process.env.REACT_APP_ENV || "";
  switch (customEnv) {
    case "production":
      env = "production";
      break;
    case "qa":
      env = "qa";
      break;
    case "staging":
      env = "staging";
      break;
    case "dev":
      env = "dev";
      break;
    default:
      env = process.env.NODE_ENV;
      break;
  }

  console.log({ env });

  return env;
}

export const environment =
  getEnvironment() === "production"
    ? {
        storage: "https://cdn.videolink.app",
        server: "https://demoserverapi.videolink.app",
        ws_url: "https://demoserver.videolink.app/videolink",
      }
    : getEnvironment() === "qa"
    ? {
        storage: "https://cdn.qa.videolink.app",
        server: "https://api.qa.videolink.app",
        ws_url: "https://ws.qa.videolink.app/videolink",
      }
    : getEnvironment() === "staging"
    ? {
        storage: "https://cdn.pre.videolink.app",
        server: "https://api.pre.videolink.app",
        ws_url: "https://ws.pre.videolink.app/videolink",
      }
    : getEnvironment() === "dev"
    ? {
        storage: "https://cdn.dev.videolink.app",
        server: "https://api.dev.videolink.app",
        ws_url: "https://ws.dev.videolink.app/videolink",
      }
    : {
        storage: "http://localhost:3003",
        server: "http://localhost:3001",
        ws_url: "http://localhost:3002/videolink",
      };

export const TOKEN_KEY = `agent_token`;

function getServerHost() {
  const apiUrl = environment.server;
  if (apiUrl) {
    return apiUrl;
  } else {
    return isProd
      ? `http://${window.location.host}`
      : `http://${window.location.hostname}:4000`;
  }
}

export const SERVER_HOST = getServerHost();
export const API_BASE_URL = `${SERVER_HOST}`;
//URL
export const maxFileImg = 1048576;
